export default "__VITE_ASSET__BBDrEuo$__"